var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangerRecycle(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeWidth: 1.636,
    clipPath: "url(#hanger_recycle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M5.739 41.352a25.093 25.093 0 01-4.61-14.528C1.129 12.921 12.4 1.65 26.319 1.65a25.042 25.042 0 0115.747 5.532"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M24.682 16.998c.506-.847 1.175-1.056 1.83-1.056 2.69 0 3.925 3.792 1.323 5.145-.61.328-1.354.52-1.354 1.368v2.052L15.27 29.46c-1.13.506-2.483.922-3.27 1.933-.447.565-.655 1.457-.254 2.097.491.803 1.577.892 2.424.966 1.041.105 2.097.045 3.153 0 5.353-.193 10.72-.074 16.089-.074h3.717c1.234 0 2.93.134 3.733-1.011.401-.58.312-1.309-.09-1.859-.728-1.026-2.052-1.412-3.137-1.933-1.086-.52-2.112-.981-3.167-1.457a221.542 221.542 0 00-5.116-2.216c-.327-.134-.654-.282-.996-.416l-2.171-.848"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M42.185 1.798l1.412 6.275-6.542 1.487"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M46.975 12.415a25.008 25.008 0 014.535 14.543c-.074 13.903-11.405 25.13-25.308 25.056a25.076 25.076 0 01-15.718-5.606"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M9.74 51.704l-.193-6.424 6.706-.193"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hanger_recycle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.313.833h52v52h-52z"
  })))));
}
export default SvgHangerRecycle;